import httpClient from "../../api/httpClient";
import Usuario from "../classes/Usuario";
import { hasInCache } from "../../helper/cacheHelper";
import { boolean } from "yup/lib/locale";
interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Usuario/All/" },
  { method: "GET", rota: "Usuario/" },
  { method: "GET", rota: "Usuario/Email/" },
  { method: "POST", rota: "Usuario/Adicionar" },
  { method: "PUT", rota: "Usuario/Atualizar" },
  { method: "DELETE", rota: "Usuario/Apagar" },
  { method: "PUT", rota: "Usuario/AtualizarSenha" },
  { method: "PUT", rota: "Usuario/{idUsuario}/AdicionarRegra/{idRegra}" },
  { method: "PUT", rota: "Usuario/{idUsuario}/RetirarRegra/{idRegra}" },
];

const cacheKey: string = "UsuarioCache";
const apiServico: String = "PORTAL"
class UsuarioDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  async Adicionar(value: Usuario) {
    try {
      const result = await super.post(calls[3].rota, value);
      return JSON.parse(result);
    } catch (erro) {
      console.log(erro);
      return false;
    }
  }

  async Atualizar(value: Usuario) {
    return super.put(calls[4].rota, value);
  }

  async AtualizarSenha(value: String[]) : Promise<boolean> {
     return super.put(calls[6].rota, value);     
  }

  async Apagar(value: Usuario) {
    return super.delete(calls[5].rota, value).then((result) => {
      return JSON.parse(result);
    }).catch((erro) => {
      console.log(erro);
      return false;
    });
  }

  async ListarAtivos(): Promise<Usuario[]> {
    let grupo: String = "";
    if (hasInCache("GrupoParceiroSelecionado"))
      grupo = String(localStorage.getItem("GrupoParceiroSelecionado"));
    return await super.Get(calls[0].rota + grupo)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async AdicionarRegra(value: Usuario, _id: number) {
    return super.put("Usuario/" + value.id.toString() + "/AdicionaRegra/" + _id.toString(), null);
  }

  async RemoverRegra(value: Usuario, _id: number) {
    return super.put("Usuario/" + value.id.toString() + "/RetiraRegra/" + _id.toString(), null);
  }

  async RecuperarPorId(id: number): Promise<Usuario> {
    return await super.Get(calls[1].rota + id.toString())
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async RecuperarPorEmail(email: string): Promise<Usuario> {
    return await super.Get(calls[2].rota + email.toString())
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  getKeyCach(): string {
    return cacheKey;
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKey);
  }

  AdicionarObjetoAoCache(value: Usuario) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

}
export default UsuarioDataset;

